import EndUserLicenseContent from './end-user-license-content.connect.js'

export default EndUserLicenseContent
